import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import { graduationRequests } from "api/graduationApi";
import QueueIcon from "@mui/icons-material/Queue";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { InternshipSessionInput } from "server/components/Fields/InternshipSessionInput";
import { useWatch } from "react-hook-form";

const FormContent = ({ filters }) => {
  const sourceInternshipSessionId = useWatch({ name: "sourceInternshipSessionId" });
  return (
    <>
      <InternshipSessionInput
        source="sourceInternshipSessionId"
        label="Клонирай от сесия"
        filter={{ structuralUnitId: filters?.structuralUnitId }}
        defaultValue={filters?.internshipSessionId}
      />

      <InternshipSessionInput
        source="targetInternshipSessionId"
        label="Клонирай в сесия"
        filter={{ structuralUnitId: filters?.structuralUnitId }}
        excludeId={sourceInternshipSessionId}
      />
    </>
  );
};

const CloneTrainingBaseDialog = ({ filters }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      sourceInternshipSessionId: filters?.internshipSessionId,
      targetInternshipSessionId: data.targetInternshipSessionId,
    };
    await dataProvider.customRequest(graduationRequests.cloneTrainingBases(), payload, "POST");
    notify("Успешно клониране на Учебна база", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={"Клониране на учебна база"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Клонирай"
          startIcon={<QueueIcon />}
        />
      }
    >
      <FormContent filters={filters} />
    </FormModal>
  );
};

export default CloneTrainingBaseDialog;
